<ng-container>
  <ion-row class="accordian-table__header-row">
    <ion-col size="2" *ngIf="accordionTableVM.options?.select && accordionTableVM.options?.select?.selectAllApplicable">
      <div (click)="toggleSelectAll($event)">
        <ion-checkbox
          [mode]="'md'"
          class="accordian-table__select-cell"
          [ngClass]="{
            'accordian-table__select-cell--isMulti': accordionTableVM.options?.select?.isMulti
          }"
          [checked]="accordionTableVM.options?.select?.selectAllChecked"
          [indeterminate]="accordionTableVM.options?.select?.selectAllIndeterminate"
        ></ion-checkbox>
      </div>
    </ion-col>
    <ion-col>
      <ion-row>
        <ion-col *ngFor="let item of accordionTableVM.headers" [size]="item.colSize" class="accordian-table__header">
          <div>{{ item.label | translate }}</div>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col *ngIf="accordionTableVM.options?.showDelete" size="2"></ion-col>
  </ion-row>

  <ng-container *ngIf="accordionTableVM.accordions.length; else accordionsEmpty">
    <div class="accordian-table__content">
      <ng-container *ngFor="let accordion of accordionTableVM.accordions; let i = index; trackBy: trackByFn">
        <div class="accordian-table__rowItem-wrpr" [id]="'AccordianRow' + accordion.id">
          <ion-row>
            <ion-col
              (click)="toggleSelectAccordion($event, i)"
              *ngIf="accordionTableVM.options?.select"
              class="accordian-table__rowCheckbox"
              size="2"
            >
              <ion-checkbox
                [mode]="'md'"
                class="accordian-table__select-cell"
                [ngClass]="{
                  'accordian-table__select-cell--isMulti': accordionTableVM.options?.select?.isMulti
                }"
                [checked]="accordion.accordionSelectionInfo?.isSelected"
                [disabled]="!!accordion.accordionSelectionInfo?.isDisabled"
              ></ion-checkbox>
            </ion-col>
            <ion-col>
              <div (click)="accordion.hideToggleButtons ? null : onToggle(accordion.id)">
                <ion-row
                  class="accordian-table__rowItem"
                  [ngClass]="{ 'accordian-table__rowItem--selected': !accordion.isMinimized }"
                >
                  <ion-col size="24" *ngIf="accordion.tag">
                    <div class="accordian-table__tag-container">
                      <ng-container *ngFor="let tag of accordion.tag; let i = index">
                        <span *ngIf="tag.frequency > 1" class="accordian-table__tag-frequency">
                          {{ tag.frequency }}
                        </span>
                        <span class="accordian-table__tag" [ngClass]="tag.class ? tag.class : ''">
                          {{ tag.displayName | translate }}
                        </span>
                      </ng-container>
                    </div>
                  </ion-col>

                  <ng-container *ngFor="let item of accordion.rowItems; let index = index">
                    <ng-container *ngIf="item.type === 'DATE_AND_TIME'">
                      <ion-col [size]="accordionTableVM.headers[index].colSize" class="accordian-table__rowItem-col">
                        <div>{{ item.timestamp | date : 'shortTime' }}</div>
                        <div class="accordian-table__rowItem-date-txt">
                          {{ item.timestamp | date : 'shortDate' }}
                        </div>
                      </ion-col>
                    </ng-container>
                    <ng-container *ngIf="item.type === 'DURATION'">
                      <ion-col [size]="accordionTableVM.headers[index].colSize" class="accordian-table__rowItem-col">
                        <div class="accordian-table__header-item accordian-table__header-item--wrap">
                          <ng-container *ngFor="let val of item.values">
                            <span>{{ val.displayName.toString() | translate }} </span>
                          </ng-container>
                        </div>
                      </ion-col>
                    </ng-container>
                    <ng-container *ngIf="item.type === 'TEXT'">
                      <ion-col [size]="accordionTableVM.headers[index].colSize" class="accordian-table__rowItem-col">
                        <div class="accordian-table__rowItem-col__text-cell">
                          <img
                            *ngIf="item.icon === 'IN_PROGRESS'"
                            src="assets/common/timeline/in-progress-marker.svg"
                          />
                          <div class="accordian-table__header-item">
                            {{ item.value | translate }}
                          </div>
                          <img
                            *ngIf="item.actionIconId === 'COPY'"
                            class="accordian-table__copy-icon"
                            src="assets/common/copy-icon-blue.svg"
                            (click)="emitRowHeaderAction($event, item.actionIconId, accordion.id)"
                          />
                        </div>
                      </ion-col>
                    </ng-container>
                    <ng-container *ngIf="item.type === 'STATUS'">
                      <ion-col [size]="accordionTableVM.headers[index].colSize" class="accordian-table__rowItem-col">
                        <div class="accordian-table__header-status" [ngStyle]="{ 'background-color': item.color }">
                          {{ item.displayName.toString() | translate }}
                        </div>
                      </ion-col>
                    </ng-container>
                    <ng-container *ngIf="item.type === 'ACTION'">
                      <ion-col [size]="accordionTableVM.headers[index].colSize" class="accordian-table__rowItem-col">
                        <div class="accordian-table__header-action">
                          <span
                            (click)="emitRowHeaderAction($event, item.actionId, accordion.id)"
                            *ngIf="item.displayName"
                          >
                            {{ item.displayName | translate }}
                          </span>
                          <img
                            class="accordian-table__header-icon"
                            (click)="emitRowHeaderAction($event, item.actionId, accordion.id)"
                            *ngIf="item.icon"
                            [src]="item.icon"
                          />
                        </div>
                      </ion-col>
                    </ng-container>
                    <ng-container *ngIf="item.type === 'PROGRESS'">
                      <ion-col [size]="accordionTableVM.headers[index].colSize" class="accordian-table__rowItem-col">
                        <ion-row>
                          <ion-col size="14" class="accordian-table__header-progress">
                            <div
                              class="accordian-table__header-progress-fill"
                              [ngStyle]="{
                                'background-color': item.barColor,
                                width: getProgressPercentage(item.currentValue, item.totalValue) + '%'
                              }"
                            ></div>
                          </ion-col>
                          <ion-col class="accordian-table__header-progress-val">
                            {{ getProgressPercentage(item.currentValue, item.totalValue) }}%
                          </ion-col>
                        </ion-row>
                      </ion-col>
                    </ng-container>
                    <ng-container *ngIf="item.type === 'PROGRESS'">
                      <ion-col [size]="accordionTableVM.headers[index].colSize" class="accordian-table__rowItem-col">
                        <ion-row>
                          <ion-col size="14" class="accordian-table__header-progress">
                            <div
                              class="accordian-table__header-progress-fill"
                              [ngStyle]="{
                                'background-color': item.barColor,
                                width: getProgressPercentage(item.currentValue, item.totalValue) + '%'
                              }"
                            ></div>
                          </ion-col>
                          <ion-col class="accordian-table__header-progress-val">
                            {{ getProgressPercentage(item.currentValue, item.totalValue) }}%
                          </ion-col>
                        </ion-row>
                      </ion-col>
                    </ng-container>
                  </ng-container>

                  <ion-col *ngIf="!accordion.hideToggleButtons" size="1">
                    <div class="accordian-table__chevron">
                      <ng-container *ngIf="!accordion.isMinimized; else hideMoreInfo">
                        <div class="accordian-table__chevron--open"></div>
                      </ng-container>
                      <ng-template #hideMoreInfo>
                        <div class="accordian-table__chevron--close"></div>
                      </ng-template>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </ion-col>
            <ion-col
              class="accordian-table__row-delete"
              *ngIf="accordionTableVM.options?.showDelete"
              size="2"
              (click)="onDelete($event, accordion.id)"
            >
              <img src="assets/common/table/ic-delete.svg" />
            </ion-col>
          </ion-row>

          <ng-container *ngIf="!accordion.isMinimized && accordion.moreInfo.length">
            <div class="accordian-table__moreInfo-wrapper">
              <div class="accordian-table__moreInfo">
                <ion-row>
                  <ng-container *ngFor="let section of accordion.moreInfo">
                    <ion-col size="24" *ngIf="section.sectionName">
                      <div class="accordian-table__section-name">
                        {{ section.sectionName | translate }}
                      </div>
                    </ion-col>
                    <ng-container *ngFor="let item of section.items">
                      <ion-col [size]="item.size" class="accordian-table__moreInfo-col">
                        <div class="accordian-table__moreInfo-col-label">
                          {{ item.label | translate }}
                        </div>
                        <div *ngIf="item.values.length === 0">--</div>
                        <div
                          *ngIf="item.values.length === 1 && item.type !== 'ROUTER_LINK'"
                          class="accordian-table__moreInfo-text"
                          [ngStyle]="{
                            'background-color': item.values[0].backgroundColor ?? 'transparent',
                            color: item.values[0].textColor ?? 'black'
                          }"
                        >
                          {{ item.values[0].displayName.toString() | translate }}
                        </div>
                        <a
                          class="accordian-table__moreInfo-col__router-link"
                          *ngIf="item.values.length === 1 && item.type === 'ROUTER_LINK'"
                          class="accordian-table__moreInfo-text"
                          [ngStyle]="{
                            'background-color': item.values[0].backgroundColor ?? 'transparent',
                            color: item.values[0].textColor ?? 'black'
                          }"
                          [routerLink]="item.values[0].routerLink"
                        >
                          {{ item.values[0].displayName.toString() | translate }}
                        </a>

                        <ng-container
                          *ngIf="item.values.length > 1 && (item.type === 'DURATION' || item.type === 'LOCATION')"
                        >
                          <div>
                            <ng-container *ngFor="let val of item.values">
                              <span>{{ val.displayName.toString() | translate }} </span>
                            </ng-container>
                          </div>
                        </ng-container>
                        <ng-container
                          *ngIf="item.values.length > 1 && item.type !== 'DURATION' && item.type !== 'LOCATION'"
                        >
                          <div class="accordian-table__moreInfo-item">
                            <span>1. {{ item.values[0].displayName.toString() | translate }}</span>
                            <img
                              *ngIf="item.values[0].icon"
                              [src]="item.values[0].icon"
                              class="accordian-table__moreInfo-icon"
                            />
                          </div>
                          <div class="accordian-table__moreInfo-item">
                            <span> 2. {{ item.values[1].displayName.toString() | translate }} </span>
                            <img
                              *ngIf="item.values[1].icon"
                              [src]="item.values[1].icon"
                              class="accordian-table__moreInfo-icon"
                            />
                          </div>
                        </ng-container>
                        <div
                          *ngIf="item.values.length > 2 && item.type !== 'DURATION' && item.type !== 'LOCATION'"
                          (click)="onViewMore(item.label, item.values)"
                          class="accordian-table__view-more"
                        >
                          {{ 'accordion_table.view-more' | translate }}
                        </div>
                      </ion-col>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="accordion.editableInfo">
                    <ng-container *ngFor="let section of accordion.editableInfo">
                      <ion-col size="24" *ngIf="section.sectionName">
                        <div class="accordian-table__section-name">
                          {{ section.sectionName | translate }}
                        </div>
                      </ion-col>
                      <ng-container *ngFor="let item of section.items">
                        <ion-col [size]="item.size" class="accordian-table__moreInfo-col">
                          <div class="accordian-table__moreInfo-col-label">
                            {{ item.label | translate }}
                          </div>
                          <ng-container *ngIf="item.value">
                            <div>
                              <span>{{ item.value.toString() | translate }}</span>
                              <img
                                (click)="emitEditableInfoAction(item.actionId, accordion.id)"
                                *ngIf="item.icon"
                                [src]="item.icon"
                                class="accordian-table__editableInfo-icon"
                              />
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.value === undefined">
                            <div
                              class="accordian-table__editable-info-action"
                              (click)="emitEditableInfoAction(item.actionId, accordion.id)"
                            >
                              {{ item.actionDislayName | translate }}
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.statusTag">
                            <div
                              [ngStyle]="{ 'background-color': item.statusTag.color }"
                              class="accordian-table__editable-info-tag"
                            >
                              <span *ngIf="item.statusTag.icon">
                                <img [src]="item.statusTag.icon" />
                              </span>
                              <span>
                                {{ item.statusTag.displayString | translate }}
                              </span>
                            </div>
                          </ng-container>
                        </ion-col>
                      </ng-container>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="accordion.actions.length">
                    <ion-col size="24" class="accordian-table__btn-row">
                      <ng-container
                        *ngFor="
                          let action of accordion.actions.slice(0, accordion.primaryActionsBtnCount ?? 2);
                          let index = index
                        "
                      >
                        <ng-container *ngIf="action.hyperTxtConf; else normalAction">
                          <div class="accordian-table__action-btn accordian-table__action-btn--secondary">
                            <ion-row>
                              <ion-col>
                                <img class="accordian-table__action-icon" [src]="action.hyperTxtConf.icon" />
                              </ion-col>
                              <ion-col>
                                <a
                                  class="accordian-table__hyper-link"
                                  [href]="action.hyperTxtConf.href"
                                  target="_blank"
                                >
                                  {{ action.displayName | translate }}</a
                                >
                              </ion-col>
                            </ion-row>
                          </div>
                        </ng-container>
                        <ng-template #normalAction>
                          <div
                            (click)="emitAction(action.actionId, accordion.id)"
                            class="accordian-table__action-btn"
                            [ngClass]="{
                              'accordian-table__action-btn--secondary':
                                action.buttonType === 'SECONDARY' || (index !== 0 && action.buttonType !== 'PRIMARY'),
                              'accordian-table__action-btn--full': action.buttonWidth === 'FULL',
                              'accordian-table__action-btn--half': action.buttonWidth === 'HALF'
                            }"
                          >
                            {{ action.displayName | translate }}
                          </div>
                        </ng-template>
                      </ng-container>
                      <ng-container *ngIf="accordion.actions.length > (accordion.primaryActionsBtnCount ?? 2)">
                        <div
                          (click)="openMoreActions($event, accordion.id, accordion)"
                          class="accordian-table__more-actions"
                        >
                          <img src="assets/common/more-actions.svg" />
                        </div>
                      </ng-container>
                    </ion-col>
                  </ng-container>
                </ion-row>
              </div>
              <div
                *ngIf="accordionTableVM.options?.showExpand"
                (click)="emitAction('EXPAND_TICKET', accordion.id)"
                class="accordian-table__expand"
              >
                <img src="assets/icon/mobile-icons/expand.svg" />
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #accordionsEmpty>
    <div class="accordian-table__no-data">{{ 'accordion_table.no-data' | translate }}</div>
  </ng-template>
</ng-container>
